import { RESET_STATE } from 'store/global/actions';

import { PLANS_ACTION_TYPE } from '../actions';

const initialQueryState = { data: [], isLoading: false, hasError: false };

// versions carries the planId it was fetched FOR — the console drops a mismatched chain instead of
// briefly rendering the previous channel's history after a channel switch.
const initialState = {
  list: initialQueryState,
  versions: { ...initialQueryState, planId: null },
  save: { isSaving: false, errorMessage: null },
  activate: { isActivating: false, errorMessage: null, pendingChangeRequest: null },
};

const upsertPlan = (plans, plan) => {
  const exists = plans.some(item => item.marginPlanId === plan.marginPlanId);

  return exists
    ? plans.map(item => (item.marginPlanId === plan.marginPlanId ? plan : item))
    : [...plans, plan];
};

const plansReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PLANS_ACTION_TYPE.SET_PLANS_LOADING:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: payload,
          hasError: payload ? false : state.list.hasError,
        },
      };

    case PLANS_ACTION_TYPE.SET_PLANS_ERROR:
      return { ...state, list: { ...state.list, isLoading: false, hasError: true } };

    case PLANS_ACTION_TYPE.GET_MARGIN_PLANS:
      return { ...state, list: { data: payload ?? [], isLoading: false, hasError: false } };

    case PLANS_ACTION_TYPE.SET_VERSIONS_LOADING:
      return {
        ...state,
        versions: {
          ...state.versions,
          isLoading: payload,
          hasError: payload ? false : state.versions.hasError,
        },
      };

    case PLANS_ACTION_TYPE.SET_VERSIONS_ERROR:
      return { ...state, versions: { ...state.versions, isLoading: false, hasError: true } };

    case PLANS_ACTION_TYPE.GET_MARGIN_PLAN_VERSIONS:
      return {
        ...state,
        versions: {
          planId: payload?.marginPlanId ?? null,
          data: payload?.data ?? [],
          isLoading: false,
          hasError: false,
        },
      };

    case PLANS_ACTION_TYPE.SET_PLAN_SAVING:
      return { ...state, save: { isSaving: payload, errorMessage: null } };

    case PLANS_ACTION_TYPE.SET_PLAN_SAVE_ERROR:
      return { ...state, save: { isSaving: false, errorMessage: payload ?? null } };

    case PLANS_ACTION_TYPE.SET_PLAN_ACTIVATING:
      return {
        ...state,
        activate: { isActivating: payload, errorMessage: null, pendingChangeRequest: null },
      };

    case PLANS_ACTION_TYPE.SET_PLAN_ACTIVATE_ERROR:
      return {
        ...state,
        activate: {
          isActivating: false,
          errorMessage: payload ?? null,
          pendingChangeRequest: null,
        },
      };

    case PLANS_ACTION_TYPE.CLEAR_PLAN_ACTIVATE_ERROR:
      return { ...state, activate: { ...state.activate, errorMessage: null } };

    case PLANS_ACTION_TYPE.SET_PLAN_ACTIVATE_PENDING_CHANGE_REQUEST:
      return {
        ...state,
        activate: { isActivating: false, errorMessage: null, pendingChangeRequest: payload },
      };

    case PLANS_ACTION_TYPE.CLEAR_PLAN_ACTIVATE_PENDING_CHANGE_REQUEST:
      return { ...state, activate: { ...state.activate, pendingChangeRequest: null } };

    case PLANS_ACTION_TYPE.UPSERT_MARGIN_PLAN:
      return {
        ...state,
        list: { ...state.list, data: upsertPlan(state.list.data, payload) },
        save: { isSaving: false, errorMessage: null },
        activate: { isActivating: false, errorMessage: null, pendingChangeRequest: null },
      };

    case PLANS_ACTION_TYPE.REMOVE_MARGIN_PLAN:
      return {
        ...state,
        list: {
          ...state.list,
          data: state.list.data.filter(item => item.marginPlanId !== payload),
        },
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default plansReducer;
